"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setViewFrozenColumnCount = void 0;
const model_1 = require("../../model");
const selectors_1 = require("../../exports/store/selectors");
const types_1 = require("../../types");
const command_manager_1 = require("../../command_manager");
exports.setViewFrozenColumnCount = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { count, viewId } = options;
        const datasheetId = (0, selectors_1.getActiveDatasheetId)(state);
        const datasheet = (0, selectors_1.getDatasheet)(state, datasheetId);
        if (!state || !datasheet) {
            return null;
        }
        const actions = [];
        const setViewFrozenColumnCountAction = model_1.DatasheetActions.setFrozenColumnCount2Action(datasheet.snapshot, { viewId, count });
        setViewFrozenColumnCountAction && actions.push(setViewFrozenColumnCountAction);
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
//# sourceMappingURL=set_view_frozen_column_count.js.map